import InformesDePagosJugadoresListView from './views/InformesDePagosJugadoresListView.vue'
import InformesDePagosCuerpoTecnicoListView from './views/InformesDePagosCuerpoTecnicoListView.vue'
import InformeView from './views/InformeView'
export default [
  {
    path: '/informes/jugadores',
    name: 'informesJugadores',
    component: InformesDePagosJugadoresListView
  },
  {
    path: '/informes/cuerpo-tecnico',
    name: 'informesCuerpoTecnico',
    component: InformesDePagosCuerpoTecnicoListView
  },
  {
    path: '/informe-pagos/:id',
    name: 'informe-pagos',
    component: InformeView
  }
]
